(function() {
	'use strict';

	angular.module('quantixApp').factory('localStorage', localStorage);
	localStorage.$inject = [ '$resource' ];
	function localStorage($resource) {
		return {};
	}

	angular.module('quantixApp').controller('InfrastructureProjectsController',
			InfrastructureProjectsController)
	InfrastructureProjectsController.$inject = [ '$scope', 'Principal', '$state','InfrastructureProjectsService','GenericService',
		'GenericServiceNew', 'ivhTreeviewBfs', '$timeout', 'ivhTreeviewOptions', 'ErrorHandlerService', '$uibModal', '$http', '$stateParams','$rootScope','$anchorScroll','$window'];

	function InfrastructureProjectsController($scope, Principal, $state, InfrastructureProjectsService,GenericService,GenericServiceNew, ivhTreeviewBfs, $timeout, ivhTreeviewOptions, ErrorHandlerService, $uibModal, $http,$stateParams,$rootScope,$anchorScroll,$window) {
		
		//$anchorScroll();
		$scope.sectorList = [];
		$scope.modeOfAwardList = [];
		$scope.awardingAuthorityList = [];		
		$scope.projectStatusList = [];
		$scope.projectCostList = [];
		$scope.slider;
		$scope.minsize;
		$scope.maxsize;
		$scope.sectorName = 'RH';
		//$scope.detailsFlag=false;
		$scope.listofobj =[];
		$scope.listofpromoterorparent =[];
		$scope.searchcomp = ' ';
		$scope.searchpromoterparent = ' ';
		$scope.searcharrcmp = [];		
		$scope.searcharrpro =[];
		$scope.selectedLocations = [];
		$scope.selectedFilterIdToLoad = null;
		$scope.selectedFilterJsonToLoad = null;
		$scope.arrow=">";
		 $scope.status = {
				    isCustomHeaderOpen: false,
				    isFirstOpen: true,
				    isFirstDisabled: false
				  };
		$scope.errorExport=false
		

		$scope.fromDate = new Date();
		$scope.toDate = new Date();
		$scope.exportFlag = false;
	
		$scope.userSectionAccessData = GenericService.getUserSectionAccessData();
		$scope.awardingDateFromModel = '';
		$scope.awardingDateToModel	= '';
		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate', 'dd-MMM-yyyy' ];
		$scope.format = $scope.formats[0];
		$scope.requiredFormat = $scope.formats[4];
		var gridData='';
		$scope.gridDataNHAI={
			dataProvider : [],
			delegate : $scope
			
		};
		$scope.gridDataPMGSY={
			dataProvider : [],
			delegate : $scope
			
		};
		$scope.gridDataNHIDCL={
			dataProvider : [],
			delegate : $scope
			
		};
		$scope.gridDataForBotToll={
			dataProvider : [],
			delegate : $scope
			
		};
		$scope.gridDataForHam={
			dataProvider : [],
			delegate : $scope
			
		};
		$scope.gridDataForBotAnnuity={
			dataProvider : [],
			delegate : $scope
			
		};
		$scope.nhaiGrid = '';
		$scope.pmgsyGrid = '';
		$scope.nhidclGrid = '';
		$scope.botTollGrid = '';
		$scope.hamGrid = '';
		$scope.botTollAnnGrid = '';
		GenericService.getUserModuleAccessData().then(function(result){
			GenericService.getUserSectionAccessData().then(function (result) {
                $scope.userSectionAccessData = result;
				if (!(($scope.userSectionAccessData["INFRASTRUCTURE.Roads"] == "Y") || ($scope.userSectionAccessData["INFRASTRUCTURE.Roads_Trial"] == "Y"))) {
					ErrorHandlerService.forbiddenError("Roads & Highways");
					return;
				}
				if ($scope.userSectionAccessData["INFRASTRUCTURE.Roads"] == "Y") {
					$scope.exportFlag = true;
				}
            });
			if (!result["INFRASTRUCTURE"]) {
				ErrorHandlerService.forbiddenError("INFRASTRUCTURE");
				return;
			}
		});

		

		$scope.init = function() {
			
			InfrastructureProjectsService.getSectorList().then(function(data) {
				$scope.sectorList = data;
				//				$scope.sectorList = $scope.sectorList.filter(e => e.sectorName != 'Renewable Energy');
				$scope.sectorList = $scope.sectorList.filter(
				    function (e) {
				        if (e.sectorName != 'Renewable Energy') return e;
				    });
				 $scope.sectorModel.push($scope.sectorList[0]);
			}, function(errordata) {
				
			});
			
			getLocationTree();
						
			InfrastructureProjectsService.getModeOfAwardList().then(function(data) {
				$scope.modeOfAwardList = data;
			}, function(errordata) {
				
			});
			
			InfrastructureProjectsService.getAwardingAuthorityList().then(function(data) {
				$scope.awardingAuthorityList = data;
			}, function(errordata) {
				
			});			
			
			InfrastructureProjectsService.getProjectStatusList().then(function(data) {
				$scope.projectStatusList = data;
			}, function(errordata) {
				
			});	
			
/*			InfrastructureProjectsService.getSelectedCompanyList().then(function(data){
				$scope.searcharrcmp = data;
			},function(errordata){	
				
				
			});
			
			
			InfrastructureProjectsService.getSelectedPromoterList().then(function(data){
				$scope.searcharrpro = data;
			},function(errordata){	
				
				
			});*/
			
			
			
			InfrastructureProjectsService.getMinMaxProjectCost().then(function(data) {
				$scope.projectCostList = data;
				
				$scope.minsize=$scope.projectCostList[0];
				$scope.maxsize=$scope.projectCostList[1];
				$scope.slider = {
					    minValue: $scope.minsize,
					    maxValue: $scope.maxsize,
					    options: {
					        floor: $scope.projectCostList[0],
					        ceil: $scope.projectCostList[1],
					        step: 1
					    }
					};
			}, function(errordata) {
				
			});
			
		}
		
		
		
		
		//Location data starts
		
		function getLocationTree() {

			var promise = InfrastructureProjectsService.getZonalLocationDetailsdata();
			promise.then(function(data) {
				$scope.sampletreedata = data;

				$scope.gridOptionsSecLoc = {
					dataProvider : $scope.sampletreedata,
					delegate : $scope
				};
			}, function(response, status, headers, config) {
				ErrorHandlerService.handleError(response, status, headers,config);
			});
		}
		
		$scope.loc = {
				locstatus : false
			};
		
		var opts = ivhTreeviewOptions(), isExpanded = opts.expandedAttribute;
		$scope.locstatus = false;
		var locgri = null;
		var indgri = null;		
		//var arrayloc = new Array();
		var arrayloc = [];
		var allKeysLocations = [];

		$scope.onGridCreationCompletedLocation = function(event) {

			if (event != null) {
				locgri = event.target;
				locgri.enableHeightAutoAdjust = true;
				locgri.validateNow();
			} else {
				locgri.enableHeightAutoAdjust = true;
				locgri.clearFilter();
				locgri.expandAll();
				locgri.setFilterValue('id', firstcharloc, indgri);
				locgri.validateNow();
			}
		};
		
		$scope.selectAllloc = function(flag) {
			allKeysLocations = [];
			if (flag) {
				arrayloc = []
				$scope.selectedLocations = [];

				if (locfiltervaluchanged) {
					$scope.selectAllflagloc = false;
				} else {
					$scope.selectAllflagloc = true;
				}
				ivhTreeviewBfs($scope.sampletreedata, opts, function(node) {					
					if (locfiltervaluchanged) {
						if (node.id.toLowerCase().includes(firstcharloc)) {
							$scope.selectedLocations.push(node.id);
							allKeysLocations.push(node.id);

							if (node.children) {
								ivhTreeviewBfs(node, opts, function(childnode) {
									allKeysLocations.push(childnode.id);
								});
							}

						}

					} else {
						allKeysLocations.push(node.id);
					}
				});

				$timeout(function() {
					locgri.setSelectedKeys(allKeysLocations, true);
				}, 100);
			} else {
				arrayloc = [];
				$scope.selectedLocations = [];
				$scope.selectAllflagloc = false;
				locgri.clearSelection();
				locgri.clearAllFilters();
				locgri.collapseAll();
				locfiltervaluchanged = false;				
			}
		}
		
		$scope.locbuttonid = 'locationButton_' + $scope.name;
		$scope.indgrididtohide = "gridIndTreeData2" + $scope.name;
		$scope.locgrididtohide = "gridlocTreeData1" + $scope.name;
		$scope.loccnt = 0;
		$scope.setLocationTree = function() {
			$('#gridIndTreeData2' + $scope.name).hide();
			$scope.loc.locstatus = true;
			$scope.showResult = false;

			$scope.gridOptionsSecLoc = {
				dataProvider : $scope.sampletreedata,
				delegate : $scope
			};

			if ($scope.loccnt == 0) {
				$scope.loccnt = 1;
				$timeout(function() {
					var l = document.getElementById('locationButton_'
							+ $scope.name);
					l.click();
				}, 100, false);
			}

		}

		$scope.setbadgesforLocation = function(evt) {
			var grid = evt.target;
			if (evt.isItemSelected) {				
				if(evt.item.id.indexOf("zone")>0){
					angular.forEach(evt.item.children, function(val, key) { 
						if(arrayloc.indexOf(val.id) < 0){
							arrayloc.push(val.id);
						}
					});
				} else{
					arrayloc.push(evt.item.id);
				}
			} else {
				if(evt.item.id.indexOf("zone")>0){
					angular.forEach(evt.item.children, function(val, key) {         	   
						arrayloc.splice(arrayloc.indexOf(val.id), 1);
					});
				} else{
					arrayloc.splice(arrayloc.indexOf(evt.item.id), 1);
				}
			}

			$timeout(function() {
				$scope.selectedLocations = angular.copy(arrayloc);
				$scope.badgeStringLoc = $scope.selectedLocations.toString();

				if ($scope.badgeStringLoc.length > 30) {
					for (var i = 0; i < $scope.selectedLocations.length; i++) {
						if ($scope.selectedLocations[i].length > 10) {
							$scope.selectedLocations[i] = $scope.selectedLocations[i].substr(0, 14)	+ '..';
						}
					}
					$scope.badgeStringLoc = $scope.selectedLocations.toString();
				} else {
					$scope.badgeStringLoc = $scope.selectedLocations.toString();
				}
			}, 100);
		}
		
		
		var locfiltervaluchanged = false;
		var firstcharloc = '';

		$scope.filerPageSortHandleloc = function(event) {
			setTimeout(function() {
						var filter = event.target.getRootFilter();
						var grid = event.target;
						if (!filter.filterExpressions.length) {
							grid.collapseAll();
							grid.validateNow();
							locfiltervaluchanged = false;
						}
						if (!locfiltervaluchanged) {
							if (event.cause == "filterChange") {
								if (filter.filterExpressions && filter.filterExpressions.length) {
									firstcharloc = filter.filterExpressions[0].expression
									locfiltervaluchanged = true;
									$scope.onGridCreationCompletedLocation(null);
								}
							}
						}
					}, 1);
		};
		
		
		
		//Location data ends		
			
		
		//Company data starts
		
		$scope.searchFilterAutocomplete = function(typedthings) {
			$scope.selected = true;
			if (typedthings == "cleanData") {
				$scope.listofobj = null;
			} else {
				GenericServiceNew.getCompaniesListByNameNew(typedthings,"COMPANYPROFILE")
						.then(function(response) {
							$scope.listofobj = response;

							if ($scope.listofobj.length == 0) {
								$scope.error = true;
								$scope.showError = true;
								$scope.errorMessages = "No records match the text entered, please change your selection.";
								$timeout(function() {
									$scope.error = false;
									$scope.showError = false;
									$scope.errorMessages = "";
								}, 2000);
							}
						}, function(errordata) {
				});
			}
		}
		
		
		$scope.setselectedvalcomp = function(obj) {
			var ifpresentcomp1 = $scope.searcharrcmp.filter(function(row) {
				return row.companyName == obj.companyName;
			});

			if (ifpresentcomp1.length == 0) {
				$scope.searcharrcmp.push(obj);
				$scope.compSearched = false;
			}
			$scope.searchcomp = ' ';
		}
		
		
		$scope.deleteFromListcmp = function(obj) {
			$scope.searcharrcmp.splice($scope.searcharrcmp.indexOf(obj), 1);
		}

		//Company data ends			
		
		//Promoter or Parent Filter Starts here
		
		$scope.searchFilterAutocompleteForPromoterOrParent = function(typedthings) {
			$scope.selected = true;
			if (typedthings == "cleanData") {
				$scope.listofpromoterorparent = null;
			} else {
				GenericServiceNew.getCompaniesListByNameNew(typedthings,"INFRASTRUCTURE")
						.then(function(response) {
							$scope.listofpromoterorparent = response;

							if ($scope.listofobj.length == 0) {
								$scope.error = true;
								$scope.showError = true;
								$scope.errorMessages = "No records match the text entered, please change your selection.";
								$timeout(function() {
									$scope.error = false;
									$scope.showError = false;
									$scope.errorMessages = "";
								}, 2000);
							}
						}, function(errordata) {
				});
			}
		}
		
		
		$scope.setselectedvalpromoterorparent = function(obj) {
			var ifpresentpro1 = $scope.searcharrpro.filter(function(row) {
				return row.companyName == obj.companyName;
			});

			if (ifpresentpro1.length == 0) {
				$scope.searcharrpro.push(obj);
				$scope.compSearched = false;
			}
			$scope.searchpromoterparent = ' ';
		}
		
		
		$scope.deleteFromListpro = function(obj) {
			$scope.searcharrpro.splice($scope.searcharrpro.indexOf(obj), 1);
		}
		
		
		
		
		
		
		
		//date popup starts
		
		$scope.popup3 = {
				opened : false
			};
		$scope.open3 = function($event) {
			$scope.popup3.opened = true;
		};		
		
		$scope.popup4 = {
				opened : false
			};
		$scope.open4 = function($event) {
			$scope.popup4.opened = true;
		};	
		
		
		
		//date popup ends
		
		
		//range slider starts
		
		/*$scope.minsize=10;
		$scope.maxsize=99;
		$scope.slider = {
			    minValue: $scope.minsize,
			    maxValue: $scope.maxsize,
			    options: {
			        floor: $scope.projectCostList[0],
			        ceil: $scope.projectCostList[1],
			        step: 1
			    }
			};	*/	
		
		//range slider ends		
		
		
		
		
		
		
		
		//code added later
		
		$scope.projectDataMap;
		$scope.displayData = function(){
			
			var flag=$scope.checkErr($scope.awardingDateFromModel,$scope.awardingDateToModel);
			if($scope.validateFilters() && flag!=false){				
				$scope.selectedFilter = $scope.createFilterJson();				
				$rootScope.selectedFilterForInfa = $scope.selectedFilter;
				
				InfrastructureProjectsService.getProjectDataMapForSelection($scope.selectedFilter).then(function(data) {
					if(data.SectorWise != null){
						$scope.projectDataMap = data.SectorWise;
						$scope.modelWiseDetailData = data.showData;
						
					//	$anchorScroll.yOffset = 50;
					//	$anchorScroll();
				
				/*		$("#displayId").click(function() {
						    $('html,body').animate({
						        scrollTop: $("#section1").offset().top},
						        'slow');
						});
						*/
						
	/*					$('html, body').animate({
							scrollTop: $("#section1").offset().top - 80
							}, 1000);*/
						
						
						
						$("#displayId").click(function() {
						    $('html, body').animate({
						        scrollTop: $("#section1").offset().top
						    }, 80);
						});
						
												
					}else{
						
						alert("Please expand your selection criteria.")
					}					
				}, function(errordata) {
					
				});
				
			}			
		}
		
		
		//show
		
		$scope.showData = function(dtoValue){	
			

			//$scope.detailsFlag=true;
			angular.forEach($scope.modelWiseDetailData ,function(value,key){
				if(key == dtoValue.modeOfAwardName){
					
					//$scope.Name=dtoValue.modeOfAwardName;
					$scope.modelNameKey = key;	
					
					$scope.currentModelData = value;
					
					
					
					
				}
			});
			
				// $scope.gridDataForBotToll = {
				// 			dataProvider : $scope.currentModelData.slice(0,10),
				// 			delegate : $scope
				// 		};
			
				// $scope.gridDataForHam ={
				// 		dataProvider : $scope.currentModelData.slice(0,10),
				// 		delegate : $scope
						
				// };
			
				// $scope.gridDataForBotAnnuity ={
				// 		dataProvider : $scope.currentModelData.slice(0,10),
				// 		delegate : $scope
						
				// };
				
				// $scope.gridDataNHIDCL={
				// 		dataProvider : $scope.currentModelData.slice(0,10),
				// 		delegate : $scope
						
				// };
				
				// $scope.gridDataPMGSY={
				// 		dataProvider : $scope.currentModelData.slice(0,10),
				// 		delegate : $scope
						
				// };
				
				// $scope.gridDataNHAI={
				// 		dataProvider : $scope.currentModelData.slice(0,10),
				// 		delegate : $scope
						
				// };
				// if($scope.nhaiGrid && dtoValue.modeOfAwardName == "National Highway Authority of India (NHAI)") {
				// 	$scope.nhaiGrid.setDataProvider($scope.currentModelData.slice(0,10));
				// 	$scope.nhaiGrid.creationComplete($scope.nhaiGrid);
				// }
				
			
			//alert(JSON.stringify(dtoValue));
		}		
		
		


		 	$scope.botTollListGridCompletion = function(event) {
			$scope.botTollGrid = event.target ? event.target : event;
			$scope.botTollGrid.setDataProvider($scope.currentModelData.slice(0,10));
			$scope.botTollGrid.validateNow();
			$("#gridForBotToll_btnSettings img").attr('title','Select columns');
		};

		$scope.hamListGridCompletion = function(event) {
			$scope.hamGrid = event.target ? event.target : event;
			$scope.hamGrid.setDataProvider($scope.currentModelData.slice(0,10));
			$scope.hamGrid.validateNow();
			$("#gridForHam_btnSettings img").attr('title','Select columns');
		};

		$scope.botAnnuityListGridCompletion = function(event) {
			$scope.botTollAnnGrid = event.target ? event.target : event;
			$scope.botTollAnnGrid.setDataProvider($scope.currentModelData.slice(0,10));
			$scope.botTollAnnGrid.validateNow();
			$("#gridForBotAnnuity_btnSettings img").attr('title','Select columns');
		};

		$scope.nhidclListGridCompletion = function(event) {
			$scope.nhidclGrid = event.target ? event.target : event;
			$scope.nhidclGrid.setDataProvider($scope.currentModelData.slice(0,10));
			$scope.nhidclGrid.validateNow();
			$("#gridForNHIDCL_btnSettings img").attr('title','Select columns');
		};

		$scope.pmgsyListGridCompletion = function(event) {
			$scope.pmgsyGrid = event.target ? event.target : event;
			$scope.pmgsyGrid.setDataProvider($scope.currentModelData.slice(0,10));
			$scope.pmgsyGrid.validateNow();
			$("#gridForPMGSY_btnSettings img").attr('title','Select columns');
		};
    	        
		$scope.nhaiListGridCompletion = function(event) {
			$scope.nhaiGrid = event.target ? event.target : event;
			$scope.nhaiGrid.setDataProvider($scope.currentModelData.slice(0,10));
			$scope.nhaiGrid.validateNow();
			$("#gridForNHAI_btnSettings img").attr('title','Select columns');
		};       
        
		
		$scope.showMoreData = function () {
			InfrastructureProjectsService.viewRoadsData($scope.selectedFilter).then(function (data) {

			}, function (errordata) {

			});
			$state.go('infraDetails', { 'data': $scope.currentModelData, 'modelName': $scope.modelNameKey, 'selectedFilter': $scope.selectedFilter });
		}
		$scope.getModelAwardName= function(data) {
			if(data == 'National Highway Authority of India (NHAI)'){
				data = 'National Highway Authority Of India (NHAI)-EPC';
			}
			return data;
		};
		$scope.saveIPFilterInDb = function(filterName) {
			if (filterName != null && filterName != "") {
				var fd = new FormData();
				var url = 'api/infrastructureProjects/saveUserIpFilter';
				fd.append('data', $scope.selectedFilter);
				fd.append('filterName', filterName);
				fd.append('sector', $scope.sectorName)
				$http.post(url, fd, {
					transformRequest : angular.identity,
					headers : {
						'Content-Type' : undefined
					}
				}).success(function(response) {
					$scope.success = 'OK';
					$timeout(function() {
						$scope.success = '';
					}, 10000);
					$scope.cancel();
					$scope.alreadySearch=null;
					$scope.showSuccessMessages("Filter saved successfully");
				}).error(function(response) {
					$scope.validateSearch = '';
					$scope.alreadySearch = "Filter Name Already Exists.";
				});
			} else {
				$scope.alreadySearch = '';
				$scope.validateSearch = "Filter Name is Required.";
			}
		}
		
		
		
		$scope.saveFilter = function() {
			
			if($scope.validateFilters()){				
				$scope.selectedFilter = $scope.createFilterJson();
				
				var modal = $uibModal.open({
					templateUrl : 'infrastructureProjects-dialog.html',
					scope : $scope
				})

				$scope.modalInstance = modal;

				$scope.cancel = function() {
					$scope.modalInstance.dismiss('cancel');
				}
			}
		}
		
		
		
		var alertMessages = [];
		$scope.validateFilters = function() {			
			/*alertMessages = [];
			if ($scope.sectorModel == null
					|| $scope.sectorModel == '') {
				alertMessages.push(" Sector ");
			}
			
			if ($scope.selectedLocations == null
					|| $scope.selectedLocations == '') {
				alertMessages.push(" State ");
			}
			
			if ($scope.modeOfAwardModel == null
					|| $scope.modeOfAwardModel == '') {
				alertMessages.push(" Mode Of Award ");
			}
			
			if ($scope.awardingAuthorityModel == null
					|| $scope.awardingAuthorityModel == '') {
				alertMessages.push(" Awarding Authority ");
			}
			
			if ($scope.projectStatusModel == null
					|| $scope.projectStatusModel == '') {
				alertMessages.push(" Project Status ");
			}
			
			if ($scope.awardingDateModel == null
					|| $scope.awardingDateModel == '') {
				alertMessages.push(" Awarding Date ");
			}*/
			
			/*if ($scope.searcharrcmp == null
					|| $scope.searcharrcmp == '') {
				alertMessages.push(" Company ");
			}*/			
			
			/*if (alertMessages.length > 0) {
				$scope.showErrorMessages("Please select " + alertMessages.toString());
				return false;
			}*/

			return true;
		}
		
		
		
		$scope.showErrorMessages = function(messageContent) {
			$scope.iferror = true;
			$scope.errorMessages = messageContent;

			$timeout(function() {
				$scope.iferror = false;
				$scope.errorMessages = "";
			}, 3000);
		}
		
		$scope.showSuccessMessages = function(messageContent) {
			$scope.ifsuccess = true;
			$scope.successMessages = messageContent;
			
			$timeout(function() {
				$scope.ifsuccess = false;
				$scope.successMessages = "";
			}, 3000);
		}
		
		
		
		$scope.selectedSector = [];
		$scope.selectedState = [];
		$scope.selectedModeOfAward = [];
		$scope.selectedAwardingAuthority = [];		
		$scope.selectedProjectStatus = [];		
		$scope.selectedCompany = [];
		$scope.selectedPromoterOrParent =[];
		var searchText = '';
		
		$scope.createFilterJson = function(){			
			
			if ($scope.sectorModel != undefined) {
				$scope.selectedSector = $scope.sectorModel.map(function(
						element) {
					return  element.sectorId
				})
			}			
			
			if ($scope.modeOfAwardModel != undefined) {
				$scope.selectedModeOfAward = $scope.modeOfAwardModel.map(function(
						element) {					
					return element.id
				})
			}
			
			
			if ($scope.awardingAuthorityModel != undefined) {
				$scope.selectedAwardingAuthority = $scope.awardingAuthorityModel.map(function(
						element) {					
					return element.id
				})
			}
			
			if ($scope.projectStatusModel != undefined) {
				$scope.selectedProjectStatus = $scope.projectStatusModel.map(function(
						element) {					
					return element.id
				})
			}
			
			if ($scope.searcharrcmp != undefined) {
				
				$rootScope.searcharrcmpforfilter=$scope.searcharrcmp;
				$scope.selectedCompany = $scope.searcharrcmp.map(function(
						element) {					
					return "<" + String(element.companyCode) + "<"
				})
			}
			
			//Promoter or Parent
			
			if ($scope.searcharrpro != undefined) {
				
				$rootScope.searcharrproforfilter = $scope.searcharrpro;
				$scope.selectedPromoterOrParent = $scope.searcharrpro.map(function(
						element) {					
					return "<" + String(element.companyName) + "<"
				})
			}
			
			
			
			
			
			
			/*searchText = '';
			searchText = "{'sector':'" + $scope.selectedSector
					+ "','state':'" + $scope.selectedLocations
					+ "','modeOfAward':'" + $scope.selectedModeOfAward
					+ "','awardingAuthority':'" + $scope.selectedAwardingAuthority
					+ "','projectStatus':'" + $scope.selectedProjectStatus
					+ "','awardingDate':'" + $scope.awardingDateModel
					+ "','projectCost':'" + $scope.slider.minValue + "," + $scope.slider.maxValue;*/
			
			searchText = "{'default':'none";
			
			if($scope.sectorModel != undefined && $scope.sectorModel != null && $scope.sectorModel != ""){
				searchText = searchText + "','sector':'" + $scope.selectedSector;	
			}
			
			if($scope.selectedLocations != undefined && $scope.selectedLocations != null && $scope.selectedLocations != ""){
				searchText = searchText + "','state':'" + $scope.selectedLocations;
			}
			
			if($scope.modeOfAwardModel != undefined && $scope.modeOfAwardModel != null && $scope.modeOfAwardModel != ""){
				searchText = searchText + "','modeOfAward':'" + $scope.selectedModeOfAward;
			}
			
			if($scope.awardingAuthorityModel != undefined && $scope.awardingAuthorityModel != null && $scope.awardingAuthorityModel != ""){
				searchText = searchText + "','awardingAuthority':'" + $scope.selectedAwardingAuthority;	
			}
			
			if($scope.projectStatusModel != undefined && $scope.projectStatusModel != null && $scope.projectStatusModel != ""){
				searchText = searchText + "','projectStatus':'" + $scope.selectedProjectStatus;	
			}
			
			if($scope.awardingDateFromModel != undefined && $scope.awardingDateFromModel != null && $scope.awardingDateFromModel != ""){
				searchText = searchText + "','awardingDateFrom':'" + $scope.awardingDateFromModel;	
			}
			
			if($scope.awardingDateToModel != undefined && $scope.awardingDateToModel != null && $scope.awardingDateToModel != ""){
				searchText = searchText + "','awardingDateTo':'" + $scope.awardingDateToModel;	
			}
			
			
			searchText = searchText + "','projectCost':'" + $scope.slider.minValue + "," + $scope.slider.maxValue;
			
			if($scope.searcharrcmp != undefined && $scope.searcharrcmp != null && $scope.searcharrcmp != ""){
				searchText = searchText + "','company':'" + $scope.selectedCompany;
			}
			
			if($scope.searcharrpro != undefined && $scope.searcharrpro != null && $scope.searcharrpro != ""){
				searchText = searchText + "','promoter':'" + $scope.selectedPromoterOrParent;
			}
			
			
			
			searchText = searchText + "'}";
			
			searchText = searchText.replace(/\'/g, "\"");
			searchText = searchText.replace(/\</g, "\'");		
			
			return searchText;
		}
		
		
		
		
		
		
		
		
		
		
		
		
		$scope.userSavedFilterList=[];
		$scope.loadFilter = function() {
			InfrastructureProjectsService.getUserSavedFilterList($scope.sectorName).then(function(data) {
				$scope.userSavedFilterList = angular.fromJson(data);				
			}, function(errordata) {
				
			});
			$("#loadFiltermodalId").modal('show');
		}
		
		
	
		$scope.setLoadId = function (id, filterJson){
			$scope.selectedFilterIdToLoad =id;
			$scope.selectedFilterJsonToLoad =filterJson;
		}
		
		
		$scope.removeIpFilterFromDb = function (id, index){
			InfrastructureProjectsService.deleteUserFilterById(id).then(function(data) {
				if(data == true){
					$scope.userSavedFilterList.splice(index, 1);
					$scope.removeShowSuccessMessages("Filter deleted successfully.");
				} else{
					$scope.removeShowErrorMessages("Filter not deleted.");
				}				
			}, function(errordata) {
				$scope.removeShowErrorMessages("Error while deleting filter.");
			});
		}
		
		
		
		$scope.removeShowErrorMessages = function(messageContent) {
			$scope.removeError = true;
			$scope.removeErrorMessages = messageContent;

			$timeout(function() {
				$scope.removeError = false;
				$scope.removeErrorMessages = "";
			}, 3000);
		}
		
		$scope.removeShowSuccessMessages = function(messageContent) {
			$scope.removeSuccess = true;
			$scope.removeSuccessMessages = messageContent;

			$timeout(function() {
				$scope.removeSuccess = false;
				$scope.removeSuccessMessages = "";
			}, 3000);
		}
		
		
		var vm = this;
		vm.selectedirsIndustry=[];
		$scope.sectorModel=[];
		$scope.projectStatusModel=[];
		$scope.modeOfAwardModel=[];
		
		var sectorArr;
		var stateArr;
		var modeOfAwardArr;
		var projectStatusArr;
		var awardingAuthorityArr;
		var projectCostArr;
		var companyArr;		
		var promoterArr;
		
		$scope.loadFilterForSelectedId = function() {
			
			if ($scope.selectedFilterIdToLoad == null || $scope.selectedFilterIdToLoad == '') {
				$scope.removeShowErrorMessages("Please select filter to load.");
				return false;
			}						
			
			var obj = JSON.parse($scope.selectedFilterJsonToLoad);
			sectorArr = obj.sector;
			stateArr = obj.state;
			modeOfAwardArr = obj.modeOfAward;
			projectStatusArr = obj.projectStatus;
			awardingAuthorityArr = obj.awardingAuthority;
			projectCostArr = obj.projectCost.split(",");
			
			$scope.searcharrcmp=[];
			if($scope.selectedFilterJsonToLoad.toString().indexOf('"company":') != -1){
				companyArr = obj.company.split(",");
				
				
				$scope.searcharrcmp=$rootScope.searcharrcmpforfilter;
/*				InfrastructureProjectsService.getSelectedCompanyList(companyArr.toString().replace(/\'/g, "")).then(function(data) {
					$scope.searcharrcmp = data;
				}, function(errordata) {
					
				});*/	
			}			
			
			$scope.searcharrpro=[];
			if($scope.selectedFilterJsonToLoad.toString().indexOf('"promoter":') != -1){
				promoterArr = obj.promoter.split(",");
				
				$scope.searcharrpro=$rootScope.searcharrproforfilter;
				
/*				InfrastructureProjectsService.getSelectedPromoterList(promoterArr.toString().replace(/\'/g, "")).then(function(data) {
					$scope.searcharrpro =data;	
					
					
				});*/
				
			}		
				
			$scope.sectorModel=[];
			if(sectorArr != undefined){
				angular.forEach($scope.sectorList, function(val, key) {         	   
		         	   if(sectorArr.split(",").includes(val.sectorId.toString())){         		   
		         		  $scope.sectorModel.push({"sectorId":val.sectorId,"sectorName":val.sectorName});
		         	   	}
				});
			}
			
			arrayloc = [];
			if(stateArr != undefined){
				$scope.loadSelectState();
			}
			
			$scope.selectedModeOfAward = [];
				if(modeOfAwardArr != undefined){
				angular.forEach($scope.modeOfAwardList, function(val, key) {         	   
		         	   if(modeOfAwardArr.split(",").includes(val.id.toString())){         		   
		         		  $scope.modeOfAwardModel.push({"id":val.id,"modeOfAward":val.modeOfAward});
		         	   	}
				});
			}
			
			$scope.projectStatusModel=[];
				if(projectStatusArr != undefined){
				angular.forEach($scope.projectStatusList, function(val, key) {         	   
	         	   if(projectStatusArr.split(",").includes(val.id.toString())){         		   
	         		  $scope.projectStatusModel.push({"id":val.id,"projectStatus":val.projectStatus});	   
	         	   	}
				});
			}
			
			$scope.awardingAuthorityModel=[];
				if(awardingAuthorityArr != undefined){
				angular.forEach($scope.awardingAuthorityList, function(val, key) {         	   
	         	   if(awardingAuthorityArr.split(",").includes(val.id.toString())){         		   
	         		  $scope.awardingAuthorityModel.push({"id":val.id,"awardAuthority":val.awardAuthority});	   
	         	   	}
				});	
			}
			
			$scope.fromDate = new Date(obj.awardingDate);
			$scope.awardingDateModel = $scope.fromDate;			
			
			$scope.minsize=$scope.projectCostList[0];
			$scope.maxsize=$scope.projectCostList[1];
			$scope.slider = {
				    minValue: projectCostArr[0],
				    maxValue: projectCostArr[1],
				    options: {
				        floor: $scope.projectCostList[0],
				        ceil: $scope.projectCostList[1],
				        step: 1
				    }
			};	
			
			$("#loadFiltermodalId").modal('hide');

		}


		$scope.loadSelectState = function(){
			arrayloc = [];
			angular.forEach(stateArr.split(","), function(val, key) {         	   
				arrayloc.push(val);
			});
			$scope.selectedLocations = angular.copy(arrayloc);
			$timeout(function() {
				locgri.setSelectedKeys($scope.selectedLocations, true);
			}, 100);		
		}

		
 		$scope.resetFilter = function(){
 			//$scope.sectorModel=[];
 			

			$scope.awardingDateFromModel = '';
			$scope.awardingDateToModel = '';
			$scope.fromDate = new Date();
			$scope.toDate = new Date();
 			
 			

 			$scope.projectStatusModel=[];
 			$scope.modeOfAwardModel=[];
 			$scope.awardingDateModel = '';
 			$scope.awardingAuthorityModel=[];
 			$scope.selectedLocations = [];
 			arrayloc=[];
 			$scope.badgeStringLoc=[];
 			$scope.selectAllloc(false);
 			$scope.searcharrcmp=[];
 			$scope.searcharrpro=[];
 			
 			
 			$scope.minsize=$scope.projectCostList[0];
			$scope.maxsize=$scope.projectCostList[1];
			$scope.slider = {
				    minValue: $scope.minsize,
				    maxValue: $scope.maxsize,
				    options: {
				        floor: $scope.projectCostList[0],
				        ceil: $scope.projectCostList[1],
				        step: 1
				    }
				};
 			
 			var searchText = '';
 			//$scope.displayData();
 		}
		
		
		// Export excel code added 

 		$scope.downloadDataInExcel = function(){

 			if($scope.selectedFilter!=undefined){
 			
			$http({
				url : 'api/infrastructureProjects/exportExcelInfraData',
				method : 'POST',
				data : $scope.selectedFilter,
				responseType : 'arraybuffer'
			})
					.success(

							function(response) {
							
								var isIE = false || !!document.documentMode;
								$scope.response = response;
								var blob = new Blob(
										[ response ],
										{
											type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
										});
								if (isIE) {

									window.navigator.msSaveOrOpenBlob(blob,
											'Infrastructure Project Report_New.xlsx');
								} else {

									var anchor = angular.element('<a/>');
									var blob = new Blob([ response ], {
										type : 'application/vnd.ms-excel'
									})
									var objectUrl = (window.URL || window.webkitURL)
											.createObjectURL(blob);
									anchor.css({
										display : 'none'
									});
									// Make sure it's not visible
									angular.element(document.body).append(
											anchor); // Attach to document
									anchor.attr({
										href : objectUrl,
										target : '_self',

										download : 'Infrastructure Project Report.xlsx'
									})[0].click();

									anchor.remove();

								}

							})
			
 			}else{
/* 				$scope.errorExport=true;
 				$scope.errorMessage="Please click on Display Data before Exporting Data"*/
 				
 				
 				alert("Please click on Display Data before Exporting Data  ");
 			}
		
		}
 		
 		// || val.id.toString() == '3'
 		$scope.modeOfAwardDefault=function(object){
 			
 			$scope.awardingAuthorityModel = [];
			angular.forEach(object, function(val, key) { 
				if(val.id==2){
					angular.forEach($scope.awardingAuthorityList, function(val, key) {         	   
			         	   if(val.id.toString() =='1' || val.id.toString() == '2' || val.id.toString() == '3'){         		   
			         		  $scope.awardingAuthorityModel.push(val);	   
			         	   	}
						});	
					
				}

				
			});
 			
 			
 		}
 		
		if($scope.fromDateTrue == true && $scope.toDateTrue == true){
			$scope.fromDateTemp = vm.fromDate;
			$scope.toDateTemp = vm.toDate
		}else{
			$scope.fromDateTemp = '';
			$scope.toDateTemp = '';
		}
		
 		
 		
 		//Date Validation
		$scope.checkErr = function(fromDate, toDate) {
			$scope.errMessage = '';
			$scope.fromDateTrue = false;
			$scope.toDateTrue = false;

			var curDate = new Date();
			if ((fromDate != '' && toDate != '') && (fromDate != undefined && toDate != undefined)){
				if (new Date(fromDate) > new Date(toDate)) {
					$scope.toDateTrue = false;
					alert("To Date should be greater than From Date.");
					return false;
				} else {
					$scope.toDateTrue = true;
				}
				if (new Date(fromDate) < curDate) {
					/*
					 * $scope.fromDateTrue = false; $scope.errMessage =
					 * 'fromDate should not be before today.'; alert("fromDate
					 * should not be before today."); return false;
					 */
					$scope.fromDateTrue = true;
				} else {
					$scope.fromDateTrue = false;
					$scope.errMessage = 'fromDate should not be before today.';
					alert("From Date should not be before Today.");
					return false;
					// $scope.fromDateTrue = true;
				}
			} else {
				$scope.fromDateTrue = true;
				$scope.toDateTrue = true;
			}
			
			
		};
 		
		
/*		$scope.getCompanyData = function(row, column) {
			
			console.log(row);
			console.log(column);

			$scope.flag ='CREDIT';
			
			if(row.companyCode!=null){
				return ('<div><a onClick=getCompany(this) companyCode="'+ row.companyCode + '" name=' +'  "'+$scope.flag +'"' + '>' +row.contractorName+ '</a></div>');
			}
			return ('<div><span>' + row.contractorName + '</span></div>');;
				
				
			}
			*/
		
		$scope.getCompanyData = function(row, column) {

			$scope.flag ='CREDIT';
			
			if(row.companyCode!=null){
				return ( ' <a onClick= "searchCompany(this, \''
						+ row.companyCode  + '\', \'' + row.contractorName + '\', \''
						+ $scope.flag + '\')"> <b>'
						 + row.contractorName + '</b></a> ');
			}
			return ('<div><span><b>' + row.contractorName + '</b></span></div>');;
				
				
			}
		
		
		
/*		var html = '<a  onClick= "generateCompanyProfile(this, \''
			+ rowData[0] + '\', \'' + rowData[2] + '\', \''
			+ rowData[1] + '\')"  id="' + rowData[0] + '" title= "'
			+ rowData[1] + '" > ' + rowData[1] + ' </a> ';*/
		
/*			if (item.ratingAgency.includes('CRISIL')) {
				return ('<div><a onClick=openCreditRatingRRANDCRRDOC(this,"RRDOC") id="'+ item.fileNameForRRDOC + '" name=' +'  "'+item.companyName +'"' + '>' + item.lastRatingActionDate + '</a></div>');
			}
			return ('<div><span id='+ item.fileNameForRRDOC + '>' + item.lastRatingActionDate + '</span></div>');
		}
		*/
		
/*		$window.openCompanyProfile=function(item, itemType) {
			
			$scope.selectCompany(item, itemType)
			
			
	}*/
		
		
/*		$window.showCompanyData=function(item){
			console.log(item);
			$stateParams.companyCode=item.companyCode;
			$stateParams.companyName=item.contractorName;
			$stateParams.flag=$scope.flag;
			
			console.log($stateParams.companyCode);
			console.log($stateParams.companyName);
			console.log($stateParams.companyName);
			
      	  $state.go('companyDetails',{'companyCode':$stateParams.companyCode,'companyName':$stateParams.companyName,'flag': $stateParams.flag});
      	  
      	  
        }
		*/
		
/*		
		$window.getCompany = function(row,column) {
			console.log(row);
			
			console.log(column);

			
			$scope.searchCompany(
					item.companyCode,
					item.contractorName,
					item.companyFlag);


	}*/
		
		
/*		$window.getCompany = function(item) {

			console.log(item);
			$scope.searchCompany(
					item.parentNode.component.companyCode,
					item.parentNode.component.data.companyName,
					item.parentNode.component.data.companyFlag);


	}*/
		
		
/*		
		$scope.selectCompany = function (item) {

			$scope.companyCode = item.companyCode;
			$scope.companyName = item.contractorName;
			if (companyObj.moduleFlag != null) {
				$scope.companyFlag = companyObj.moduleFlag;
			} else {
				$scope.companyFlag = companyObj.companyFlag;
			}
			
			$scope.companyFlag=$scope.flag;
			$scope.searchCompany($scope.companyCode, $scope.companyFlag, null,
				$scope.companyName);

		}
		*/
		


		
		/*$window.searchCompany = function(event, companyCodeToview, companyName,
				flag) {

			if (companyCodeToview != "") {
				var promise = GenericServiceNew
						.findCompanyPresentOrNot(companyCodeToview);
				promise
						.then(function(companyFoundFlag) {
							if (companyFoundFlag) {
								if (flag == 'SME' || flag == 'NSIC') {
									$state.go('smeDetails', {
										'companyCode' : companyCodeToview,
										'flag' : flag
									})
									$anchorScroll();
								} else {
									// $scope.cancel();
									$state.go('companyDetails', {
										'companyCode' : companyCodeToview,
										'companyName' : companyName,
										'flag' : flag
									})
									$anchorScroll();
								}

							} else {
								$scope.errorMessages = "Cannnot able to see Company details for this company.";
								$scope.error = true;

								$timeout(function() {

									$scope.error = false;
									$scope.errorMessages = "";

								}, 5000);
								$window.scrollTo(0, 0);
							}
						});
			}

		}*/
		
		$window.searchCompany = function(object,companyCodeToview, companyName,
				companyFlag) {
			if (companyCodeToview != "") {
				
				if (companyFlag == 'SME' || companyFlag == 'NSIC') {
					var paramsValue = {
							'companyCode' : companyCodeToview,
							'flag' : companyFlag
						};
					var url = $state.href('smeDetails');
					$window.localStorage['companyCodeToRedirect']=JSON
					.stringify(paramsValue);;
					$window.open(url,'_blank');
					
				} else {
					var paramsValue = {
							'companyCode' : companyCodeToview,
							'flag' :companyFlag,
							'companyName' : companyName
						};
				var url = $state.href('companyDetails');
				$window.localStorage['companyCodeToRedirect']=JSON
				.stringify(paramsValue);
				$window.open(url,'_blank');
					
					
				}
				$anchorScroll();
			}
		}
	
		$scope.addORremoveFlag = false;
		$scope.addORRemoveFun = function() {
			$scope.addORremoveFlag = $scope.addORremoveFlag;
		
			if ($scope.addORremoveFlag == true) {
				$scope.addORremove = 'add';
				$scope.previousRatingText = 'Remove';

			} else if ($scope.addORremoveFlag == false) {
				$scope.addORremove = 'remove';
				$scope.previousRatingText = 'Add';
				$scope.addORremoveFlag = false;

			}

			$scope.addORremoveFlag = !$scope.addORremoveFlag;
		}
		$scope.addORRemoveFun();
		
		
		
		
 		
 		
		$scope.init();
		$timeout(function(){
		if($rootScope.selectedFilterForInfa != null && $rootScope.selectedFilterForInfa != undefined){
			$scope.selectedFilterIdToLoad = '1';
			$scope.selectedFilterJsonToLoad = $rootScope.selectedFilterForInfa;
			$rootScope.selectedFilterForInfa=null;
			$scope.loadFilterForSelectedId();
			$scope.displayData();
		}
		},2000);
		

	}
})();
